<script>
import { linkifyParts } from "@/shared/linkify";

// Texto com os links clicáveis (card 86akj6ghg). Funcional e sem v-html: o
// texto continua sendo texto, só os trechos de URL viram <a>.
//
// O mousedown do link não sobe: no mural de stickers o mousedown começa o
// arraste, e o clique no link seria engolido por ele.
export default {
  name: "LinkifiedText",
  functional: true,
  props: {
    text: { type: String, default: "" },
    tag: { type: String, default: "span" },
  },
  render(h, { props, data }) {
    const children = linkifyParts(props.text).map((part) =>
      part.href
        ? h(
            "a",
            {
              class: "linkified__link",
              attrs: {
                href: part.href,
                target: "_blank",
                rel: "noopener noreferrer",
              },
              on: {
                mousedown: (event) => event.stopPropagation(),
                click: (event) => event.stopPropagation(),
              },
            },
            part.text
          )
        : part.text
    );

    return h(props.tag, data, children);
  },
};
</script>

<style>
.linkified__link {
  color: inherit;
  font-weight: 600;
  text-decoration: underline;
  word-break: break-all;
}
</style>
